import React from "react";
import { Link } from "react-router-dom";

import LocationSearch from "./LocationSearch";

import ServicesSection from "../components/ServicesSection";
import ProviderResults from "../components/ProviderResults";
import JobEstimateCalculator from "../components/JobEstimateCalculator";

const Home: React.FC = () => {
  return (
    <>
      <section className="space-y-8">
        <div className="text-center py-12">
          <h1 className="text-4xl font-bold">
            Find Local Handymen You Can Trust
          </h1>
          <p className="text-lg mt-4 text-gray-600">
            Search by location, State, LGA or service category
          </p>
        </div>

        <LocationSearch />
      </section>
      <section className="bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4">
          <ProviderResults />
        </div>
      </section>

      <section className="bg-white py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-4 max-w-7xl mx-auto">
          {[
            {
              title: "POST A PROJECT",
              desc: "Tell us what you need done",
              href: "/post-job",
            },
            {
              title: "FIND WORKMAN",
              desc: "Find a workman in your area now",
              href: "/search",
            },
            {
              title: "BECOME A PROVIDER",
              desc: "List your business for free",
              href: "/register-provider",
            },
            {
              title: "HOW IT WORKS",
              desc: "Free connect",
              href: "/how-it-works",
            },
          ].map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="group block text-center bg-white text-black border-b-4 border-yellow-500 px-6 py-6 shadow-md hover:bg-yellow-500 hover:text-white transition duration-300 ease-in-out"
            >
              <h2 className="text-sm font-semibold mb-2">{item.title}</h2>
              <p className="text-xs">{item.desc}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className="px-4 py-12 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-800 mb-10">
            How It Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                step: "1",
                title: "Search",
                desc: "Tell us your state, LGA and the service you need, or search near you automatically.",
              },
              {
                step: "2",
                title: "Compare & Book",
                desc: "Compare providers by price, rating and reviews from past customers, then book directly.",
              },
              {
                step: "3",
                title: "Get It Done",
                desc: "Pay securely through Paystack and leave a review once the job is complete.",
              },
            ].map((item) => (
              <div key={item.step} className="text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-green-700 text-white font-bold flex items-center justify-center mb-4">
                  {item.step}
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 py-12 bg-gray-50">
        <div className="max-w-5xl mx-auto text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
            Not Sure What It'll Cost?
          </h2>
          <p className="text-gray-500 mt-2">
            Get a quick price estimate before you book.
          </p>
        </div>
        <JobEstimateCalculator />
      </section>

      <section className="px-4 py-12">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              title: "Verified Providers",
              desc: "Providers can be verified by our team before they're marked as trusted on their profile.",
            },
            {
              title: "Local Reach",
              desc: "Search by state and LGA, or find providers nearest to your current location.",
            },
            {
              title: "Secure Payments",
              desc: "Bookings are paid for securely through Paystack — we never store your card details.",
            },
          ].map((item) => (
            <div key={item.title} className="text-center px-4">
              <h3 className="font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="px-4 py-8 bg-white">
        <ServicesSection />
      </section>

      <section className="bg-green-700 py-14 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Ready to get started?
          </h2>
          <p className="text-green-100 mb-8">
            Find a trusted handyman near you, or list your business for free.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/search"
              className="bg-white text-green-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition"
            >
              Find a Handyman
            </Link>
            <Link
              to="/register-provider"
              className="border border-white text-white font-semibold px-6 py-3 rounded-lg hover:bg-green-600 transition"
            >
              List Your Business
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
